// extracted by mini-css-extract-plugin
export default {"depositCard":"DepositeCard_depositCard__8cP7w","depositTitle":"DepositeCard_depositTitle__dmyGG","bonus":"DepositeCard_bonus__JcMcR","free":"DepositeCard_free__KkGhM"};